import { adminApi, SERVER_ERROR_MESSAGE, toAdminErrorMessage } from '../auth/adminApi';

// 기업 문의 목록을 조회한다. GET /admin/api/contact/list
export async function getContacts() {
    let data;
    try {
        ({ data } = await adminApi.get('/admin/api/contact/list'));
    } catch (error) {
        throw new Error(toAdminErrorMessage(error));
    }
    if (!Array.isArray(data)) throw new Error(SERVER_ERROR_MESSAGE);
    return data;
}

// 기업 문의 상세를 조회한다. GET /admin/api/contact/:id
export async function getContact(id) {
    try {
        const { data } = await adminApi.get(`/admin/api/contact/${encodeURIComponent(id)}`);
        return data;
    } catch (error) {
        throw new Error(toAdminErrorMessage(error, '문의를 찾을 수 없습니다.'));
    }
}
